import { MutationTree } from 'vuex'
import { LocatorState } from './types'

export const mutations: MutationTree<LocatorState> = {
  setSearch(state, payload) {
    state.search = payload
  },
}
